export enum LayoutNames {
  AuthForm = 'auth-form-layout',
  InProduct = 'in-product-layout',
}
